
















































import {
  computed,
  defineNuxtComponent,
  ref,
  vue3Model,
  watch
} from '~/utils/nuxt3-migration'
import { useI18n } from '~/compositions/i18n'
import CImg from '~/components/shared/configurable/image/CImg.vue'
import { defineComponentTranslations } from '~/utils/i18n'

export default defineNuxtComponent({
  model: vue3Model,
  components: {
    CImg
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    displayUrl: {
      type: String,
      default: null
    },
    target: {
      type: String,
      default: '_self'
    }
  },
  setup(props, { emit }) {
    const { t } = useI18n()

    const visible = ref(props.modelValue)

    watch(
      () => props.modelValue,
      newValue => {
        visible.value = newValue
      }
    )
    watch(visible, newValue => {
      emit('update:modelValue', newValue)
    })

    const isPlotUrl = computed(() => {
      const { hostname } = new URL(props.url)
      return hostname === 'plot.gr' || hostname === 'www.plot.gr'
    })

    const isPlotNewUrl = computed(() => {
      return isPlotUrl.value && props.url.includes('/classifieds/new')
    })

    const title = computed(() => {
      return isPlotUrl.value
        ? t("you're being redirected to plot.gr")
        : t("you're about to exit car.gr")
    })

    const imgSrc = computed(() => {
      const path = '/nuxt-static/img/external-link-mediator'
      if (isPlotUrl.value) return `${path}/car-to-plot-redirect.svg`
      return `${path}/car-to-anywhere-else.svg`
    })

    function close() {
      visible.value = false
    }

    return {
      visible,
      isPlotUrl,
      imgSrc,
      title,
      close,
      isPlotNewUrl
    }
  },
  i18n: defineComponentTranslations({
    subtitle: {
      en: 'Real estate classifieds from private sellers and realtors',
      el: 'Αγγελίες ακινήτων από ιδιώτες και μεσίτες'
    },
    classified_also_at_car: {
      en: 'The classified will also be posted on car.gr',
      el: 'Η αγγελία θα καταχωρηθεί αυτόματα και στο car.gr'
    }
  })
})
